import { Routes, Route, useParams } from 'react-router-dom';
import { ApplicantRequestContainer } from '../components/applicant-request.container';
import { CredentialVerificationVersionRouter } from '../../cases/credential-verification/version-router';
import { IdentityVerificationVersionRouter } from '../../cases/identity-verification/version-router';
import { ArchivedSummary as CredentialVerificationArchivedSummary } from '../../cases/credential-verification/archive/pages/archived-summary';
import { ArchivedSummary as IdentityVerificationArchivedSummary } from '../../cases/identity-verification/archive/pages/archived-summary';
import { SendReportVersionRouter } from '../../cases/send-report/version-router';
import { ArchivedSummary as SendReportArchivedSummary } from '../../cases/send-report/archive/pages/archived-summary';

interface ApplicantProfileRequestProps {
  isApplicantSection?: boolean;
}

export const ApplicantProfileRequest: React.FC<ApplicantProfileRequestProps> = () => {
  const { applicantId } = useParams();
  return (
    <Routes>
      <Route path="/" element={<ApplicantRequestContainer applicantId={applicantId} />}>
        <Route path="/cases/:caseId/case-type/credential-verification/active/*" element={<CredentialVerificationVersionRouter isApplicantSection />} />
        <Route path="/cases/:caseId/case-type/credential-verification/archived/*" element={<CredentialVerificationArchivedSummary isApplicantSection />} />
        <Route path="/cases/:caseId/case-type/send-report/active/*" element={<SendReportVersionRouter isApplicantSection />} />
        <Route path="/cases/:caseId/case-type/send-report/archived/*" element={<SendReportArchivedSummary isApplicantSection />} />
        <Route path="/cases/:caseId/case-type/id-verification/active/*" element={<IdentityVerificationVersionRouter isApplicantSection />} />
        <Route path="/cases/:caseId/case-type/id-verification/archived/*" element={<IdentityVerificationArchivedSummary isApplicantSection />} />
      </Route>
    </Routes>
  );
};
